window.SpinWheel = {
  open: () => {
    const root = document.querySelector('#sw-root');
    if (!root) return;
    root.classList.remove('sw-hidden');
    root.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  },
  close: () => {
    const root = document.querySelector('#sw-root');
    if (!root) return;
    root.classList.add('sw-hidden');
    root.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  },
  reset: () => localStorage.removeItem('sw-last')
};
